var jaccardD = require('./../distances/jaccard');

module.exports = function jaccard(a, b) {
    return 1 - jaccardD(a, b);
};



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/similarities/jaccard.js
// module id = 147
// module chunks = 0